import { format, Locale } from 'date-fns'
import { DATE_FORMATS } from 'src/config/constants'

export const getDateStr = (locale: Locale, dateOfNextAvailableSlot?: Date): string | undefined => {
  if (!dateOfNextAvailableSlot) return
  return format(dateOfNextAvailableSlot, DATE_FORMATS.DAY_MONTH_YEAR.de, { locale })
}
